"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Media = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
require("react-multi-carousel/lib/styles.css");
var Icon_1 = require("../../atoms/Icon");
var icons_1 = require("../../icons");
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
var videoFormats = ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'flv'];
exports.Media = react_1.default.memo(function (_a) {
    var uploadButton = _a.uploadButton, attachmentList = _a.attachmentList, deleteHandler = _a.deleteHandler;
    var classes = (0, styles_1.default)();
    var responsive = (0, react_1.useMemo)(function () { return ({
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 10,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 8,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 8,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 7,
        },
    }); }, []);
    var isTFile = (0, react_1.useCallback)(function (object) { return object.file !== undefined; }, []);
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ justifyContent: "flex-start" }, { children: uploadButton })), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ justifyContent: "flex-end", flexGrow: "1", maxWidth: "85%" }, { children: (0, jsx_runtime_1.jsx)(react_multi_carousel_1.default, __assign({ className: classes.root, partialVisible: true, itemClass: "image-item", responsive: responsive }, { children: attachmentList.map(function (item) {
                        var _a, _b, _c;
                        var params = {
                            key: '',
                            handler: function empty() { },
                            isImage: false,
                            name: '',
                            src: '',
                        };
                        if (isTFile(item)) {
                            params = {
                                key: item.file.name,
                                handler: function () { return deleteHandler(item.file.name, 'name'); },
                                isImage: item.file.type.includes('image'),
                                name: item.file.name,
                                src: URL.createObjectURL(item.file),
                            };
                        }
                        else {
                            var validItem = item;
                            var isVideo = videoFormats.includes(validItem.type);
                            var imgSrc = isVideo ? (_a = item === null || item === void 0 ? void 0 : item.thumbnail) === null || _a === void 0 ? void 0 : _a.link : (_b = item === null || item === void 0 ? void 0 : item.web) === null || _b === void 0 ? void 0 : _b.link;
                            // fallback to hi-res if web.link isn't available
                            var imgSrcWithFallback = imgSrc || ((_c = item === null || item === void 0 ? void 0 : item.original) === null || _c === void 0 ? void 0 : _c.link);
                            params = {
                                key: item.thumbnail.id,
                                handler: function () { return deleteHandler(item.thumbnail.id, 'thumbnail.id'); },
                                isImage: !isVideo,
                                name: item.thumbnail.key.split('/')[2],
                                src: imgSrcWithFallback,
                            };
                        }
                        return ((0, jsx_runtime_1.jsx)(atoms_1.DeleteItemContainer, __assign({ handler: params.handler, width: "150px", height: "150px" }, { children: params.isImage ? ((0, jsx_runtime_1.jsx)("img", { "data-testid": "image", className: classes.item, alt: params.name, src: params.src })) : ((0, jsx_runtime_1.jsxs)(core_1.Grid, __assign({ container: true, className: classes.iconItem, alignItems: "center", justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { children: (0, jsx_runtime_1.jsx)(icons_1.Video, { "data-testid": "video" }) }), (0, jsx_runtime_1.jsx)(atoms_1.EllipsedLongText, __assign({ width: "135px" }, { children: params.name }))] }))) }), params.key));
                    }) })) }))] })));
});
